export function debounce<T extends (...args: any[]) => void>(fn: T, delay = 0) {
    let timer: NodeJS.Timeout | undefined;

    function debounced(...args: Parameters<T>) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
    }

    debounced.clear = () => {
        if (timer) clearTimeout(timer);
    };

    return debounced as T & { clear: () => void };
}
